import { TimePickerProps } from './types';

export const weekday = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const activeTileClass = `.react-calendar__tile.react-calendar__tile--active`;

export const curWeekBarHeight = 36;

export const initTimePickerValue: TimePickerProps['value'] = {
  h: 11,
  m: 0,
  amPm: 'am',
};

// todo revise with @Ler, maybe unneeded variable
export const WIDTH = 310;
